export const FRANCHISE_DASHBOARD_SCREEN = "/";
export const REVENUE_SUMMARY_SCREEN = "/revenue-summary";
